import { z } from 'zod';
import { ClientAttachmentSchema } from './client-attachments';

export const ThreadKindSchema = z.enum(['internal', 'client']);
export type ThreadKind = z.infer<typeof ThreadKindSchema>;

export const CommentSchema = z.object({
  id: z.string().guid(),
  postId: z.string().guid(),
  kind: ThreadKindSchema,
  // Author display name: the commenting user's full name (or email), or for a
  // client comment the client's e-mail. Null only if it can't be resolved.
  authorName: z.string().nullable(),
  // The authoring user's id when an internal user wrote it; null for client comments.
  authorId: z.string().guid().nullable(),
  body: z.string(),
  createdAt: z.string().datetime(),
  // When a staff reply in the client thread was e-mailed to the client; null if not (yet) or n/a.
  clientNotifiedAt: z.string().datetime().nullable(),
  /** Client-thread images; absent when none (and always on the internal thread). */
  attachments: z.array(ClientAttachmentSchema).optional(),
});
export type Comment = z.infer<typeof CommentSchema>;

export const CreateCommentSchema = z.object({
  body: z.string().min(1).max(8000),
  kind: ThreadKindSchema,
});
export type CreateComment = z.infer<typeof CreateCommentSchema>;
